import { t } from '../lib/i18n';

export function Footer() {
  return (
    <footer className="relative border-t border-line bg-bg py-12">
      <div className="mx-auto max-w-6xl px-6 sm:px-12 lg:px-20">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
          <div className="flex flex-col gap-2">
            <p className="text-[10px] font-medium uppercase tracking-[0.25em] text-accent">
              {t('footer.about')}
            </p>
            <div className="flex items-center gap-2">
              <img
                src="/null.png"
                alt="nullscience"
                width={32}
                height={32}
                className="h-6 w-6 shrink-0 rounded-sm opacity-85"
                loading="lazy"
                decoding="async"
              />
              <p className="text-[11px] text-ink-subtle">
                © {new Date().getFullYear()} nullscience
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-[10px] font-medium uppercase tracking-[0.25em] text-accent">
              {t('footer.builtWithAi')}
            </p>
            <span className="text-[11px] text-ink">
              Builder — nullscience.ai
            </span>
          </div>
          <div className="flex flex-col gap-2 sm:text-right">
            <p className="text-[10px] font-medium uppercase tracking-[0.25em] text-accent">
              {t('footer.legal')}
            </p>
            <p className="text-[11px] text-ink-subtle">
              {t('footer.rights')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
